export default __webpack_public_path__ + "static/media/karpagam.f2094f57.png";